var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSellsIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M45.8149 26.8419C46.22 23.7388 45.9584 20.5851 45.0474 17.5913C44.1363 14.5974 42.5969 11.8325 40.532 9.48113C38.4671 7.12976 35.9241 5.2461 33.0731 3.956C30.222 2.6659 27.1285 1.99905 23.9991 2C18.1646 2 12.569 4.31776 8.44339 8.44339C4.31776 12.569 2 18.1646 2 23.9991C2 29.8336 4.31776 35.4292 8.44339 39.5548C12.569 43.6804 18.1646 45.9982 23.9991 45.9982",
    stroke: "#FFDB59",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.6661 19.1104H16.6905",
    stroke: "#FFDB59",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M31.3321 19.1104H31.3566",
    stroke: "#FFDB59",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.8882 31.3322C19.4966 32.8965 21.7014 33.7765 23.9991 33.7765C26.2968 33.7765 28.5016 32.8965 30.11 31.3322",
    stroke: "#FFDB59",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M31.3321 41.1095L36.2208 45.9982L45.9982 36.2208",
    stroke: "#FFDB59",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellsIcon3);
export default __webpack_public_path__ + "static/media/sells-icon3.02c09f9e2dd4f5e931055eb96191936f.svg";
export { ForwardRef as ReactComponent };